import PreScreeningWelcoming from './PreScreeningWelcoming.component';

export default PreScreeningWelcoming;
